import ProductAuthorModal from "./product-author-modal";

export default ProductAuthorModal;